    import { InjectionToken } from '@angular/core';

    export interface Config {
    api: {
        baseUrl: string;
    };
    keycloak: {
        url: string;
        realm: string;
        clientId: string;
    };
    googleMaps?: {
        apiKey: string;
    };
    }

    export const APP_CONFIG = new InjectionToken<Config>('Application Config');